"use strict";

var PropTypes = require("prop-types");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class CommunicationTypeSelector extends React.Component {
	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				config={this.props.communicationTypeConfig}
				wizard={ContactUsStore.get("wizardCommunicationTypes")}
				wizardValuesKey="allowedCommunicationTypes"
				configKey="availableCommunicationTypes"
				reactComponentName="CommunicationTypeSelector"
				selectClassName="communication-type-selector"
				optionsClassName="availableCommunicationTypes"
				selectNameAttribute="communication.type"
			/>
		);
	}
}

CommunicationTypeSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	communicationTypeConfig: PropTypes.object,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string
};

module.exports = CommunicationTypeSelector;
